<template>
  <div class="product-container">
    <nav class="add-navigation">
      <div class="custom-row row w-75">
        <div class="col col-lg-4 col-md-5 col-xs-12">
          <search-input
            class="search-input"
            type="text"
            v-model="Searched"
            placeholder="Search for Workflow"
          />
        </div>
      </div>
      <div class="primary-button">
        <primary-button
          @click.native="$router.push({name: 'company-admin-add-workflow'})"
        >Add Workflow</primary-button>
      </div>
    </nav>
    <loader :loading="loading" v-if="loading" />
    <template v-if="!loading">
      <div class="table_div" style="width:100%;overflow-x:auto;overflow-y:hidden">
        <table class="Invoice_table">
          <thead>
            <tr class="Invoice_table_header">
              <th>Name</th>
              <th>Created On</th>
              <th>Created By</th>
              <th>Assigned To</th>
              <th></th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="line"
              v-if="smsWorkflows.length > 0"
              v-for="(smsWorkflow, k) in smsWorkflows"
              :key="k"
            >
              <td class="user_active" style="min-width: 100px">{{smsWorkflow.name}}</td>
              <td style="min-width: 100px">{{smsWorkflow.createdOn}}</td>
              <td class="created_by" style="min-width: 100px">
                <img
                  v-if="smsWorkflow.createdBy && companyLogoId"
                  class="popup_image"
                  :src="`http://88.198.219.62/api_smsc/v1/file/${companyLogoId}`"
                  alt
                />
                {{smsWorkflow.createdBy}}
              </td>
              <td class="created_by" style="min-width: 100px">{{smsWorkflow.assignedTo}}</td>
              <td class="icon-right" style="min-width: 100px">
                <svg
                  @click="$router.push({name: 'company-admin-edit-workflow', params:{id: smsWorkflow.smsWorkflowId}})"
                  class="svg-grey"
                  width="30px"
                  height="30px"
                  viewBox="0 0 30 30"
                  version="1.1"
                >
                  <path
                    d="M21.0636684,5 L16.5223005,5 C16.0222902,5 15.6155648,5.41380074 15.6155648,5.92250923 L15.6155648,19.7548339 C15.6155648,20.0601476 15.7303938,20.4698893 15.8885285,20.7291513 L18.1395544,24.4204428 C18.2910881,24.6688561 18.5293057,24.8114391 18.793057,24.8114391 C19.0568083,24.8114391 19.2949534,24.6688561 19.4465596,24.420369 L21.6974404,20.7292251 C21.8556477,20.4698155 21.9704767,20.0601476 21.9704767,19.7548339 L21.9704767,5.92250923 C21.9704041,5.41380074 21.5636062,5 21.0636684,5 Z M19.1930363,22.7361624 L18.3929326,22.7361624 L17.1373575,20.6773432 L20.4485389,20.6773432 L19.1930363,22.7361624 Z M16.7035751,19.5703321 L16.7035751,8.61188192 L18.2488705,8.61188192 L18.2488705,19.5703321 L16.7035751,19.5703321 Z M19.3370259,19.5703321 L19.3370259,8.61188192 L20.8823212,8.61188192 L20.8823212,19.5703321 L19.3370259,19.5703321 Z M20.8823212,6.10701107 L20.8823212,7.50487085 L16.7036477,7.50487085 L16.7036477,6.10701107 L20.8823212,6.10701107 Z M16.4717409,23.8886347 C16.7721969,23.8886347 17.0157824,24.1364576 17.0157824,24.4421402 C17.0157824,24.7478229 16.7721969,24.9956458 16.4717409,24.9956458 L8.56943005,24.9956458 C8.26897409,24.9956458 8.0253886,24.7478229 8.0253886,24.4421402 C8.0253886,24.1363838 8.26897409,23.8886347 8.56943005,23.8886347 L16.4717409,23.8886347 Z"
                    id="path-1"
                  />
                </svg>
                <svg
                  @click="deletSmsWorkflow(smsWorkflow.smsWorkflowId)"
                  class="svg-grey"
                  width="30px"
                  height="30px"
                  viewBox="0 0 30 30"
                  version="1.1"
                >
                  <path
                    d="M22.0359259,7.63839416 L18.7919259,7.63839416 L18.7919259,6.35036496 C18.7919259,5.60576642 18.1771852,5 17.4215556,5 L12.5477037,5 C11.7920741,5 11.1773333,5.60576642 11.1773333,6.35036496 L11.1773333,7.63839416 L7.93333333,7.63839416 C7.42274074,7.63839416 7.00740741,8.04766423 7.00740741,8.55080292 L7.00740741,10.2229927 C7.00740741,10.7261314 7.42274074,11.1354015 7.93333333,11.1354015 L8.47111111,11.1354015 L8.47111111,23.6922628 C8.47111111,24.3966423 9.05266667,24.969635 9.76740741,24.969635 L20.2017778,24.969635 C20.9165185,24.969635 21.4980741,24.3966423 21.4980741,23.6922628 L21.4980741,11.1354745 L22.0359259,11.1354745 C22.5465185,11.1354745 22.9618519,10.7262044 22.9618519,10.2230657 L22.9618519,8.55080292 C22.9618519,8.04773723 22.5464444,7.63839416 22.0359259,7.63839416 Z M12.2884444,6.35036496 C12.2884444,6.21189781 12.4071852,6.09489051 12.5477037,6.09489051 L17.4215556,6.09489051 C17.5620741,6.09489051 17.6808148,6.21189781 17.6808148,6.35036496 L17.6808148,7.63839416 L12.2884444,7.63839416 L12.2884444,6.35036496 Z M20.386963,23.6923358 C20.386963,23.7912409 20.3021481,23.8748175 20.2017778,23.8748175 L9.76740741,23.8748175 C9.66703704,23.8748175 9.58222222,23.7912409 9.58222222,23.6923358 L9.58222222,11.1354745 L20.386963,11.1354745 L20.386963,23.6923358 Z M21.8507407,10.0405839 L8.11851852,10.0405839 L8.11851852,8.73328467 L21.8507407,8.73328467 L21.8507407,10.0405839 Z M11.7328889,22.3270073 C11.426,22.3270073 11.1773333,22.0818978 11.1773333,21.779562 L11.1773333,13.4284672 C11.1773333,13.1261314 11.426,12.8810219 11.7328889,12.8810219 C12.0397037,12.8810219 12.2884444,13.1261314 12.2884444,13.4284672 L12.2884444,21.779562 C12.2884444,22.0818978 12.0397037,22.3270073 11.7328889,22.3270073 Z M14.9846667,22.3270073 C14.6778519,22.3270073 14.4291111,22.0818978 14.4291111,21.779562 L14.4291111,13.4284672 C14.4291111,13.1261314 14.6777778,12.8810219 14.9846667,12.8810219 C15.2915556,12.8810219 15.5402222,13.1261314 15.5402222,13.4284672 L15.5402222,21.779562 C15.5402222,22.0818978 15.2915556,22.3270073 14.9846667,22.3270073 Z M18.2363704,22.3270073 C17.9294815,22.3270073 17.6808148,22.0818978 17.6808148,21.779562 L17.6808148,13.4284672 C17.6808148,13.1261314 17.9294815,12.8810219 18.2363704,12.8810219 C18.5432593,12.8810219 18.7919259,13.1261314 18.7919259,13.4284672 L18.7919259,21.779562 C18.7919259,22.0818978 18.5432593,22.3270073 18.2363704,22.3270073 Z"
                    id="path-1"
                  />
                </svg>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col col-lg-6 col-md-7 col-xs-12 per-page">
        <span class="filter_by">Show Per Page:</span>
        <div class="primary-input-container choose-type perPage">
          <primary-select
            type="text"
            @input="changePerPage"
            v-model="per_page" :is-cross="false"
            class="choose-type perPage"
            placeholder="Select"
          >
            <option :value="item" v-for="(item,key) in pages" :key="key">{{item}}</option>
          </primary-select>
        </div>
      </div>
      <pagination-component
        @change-page="changePage($event)"
        :page="Page"
        :perPage="per_page"
        :total="TotalPages"
        :qnt="smsWorkflows.length"
      />
    </template>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    Loader: () => import("@/components/Loader.vue")
  },
  data: () => ({
    smsWorkflows: [],
    Page: 0,
    TotalPages: null,
    Searched: "",
    companyLogoId: null,
    pages: [10, 20, 50, 100, 200],
    per_page: 10,
    loading: true
  }),
  created() {
    this.companyLogoId = this.$store.state.company.company.contact.logo_file_uuid;
    this.getSmsWorkflowList();
  },
  watch: {
    Searched() {
      this.Page = 0;
      this.getSmsWorkflowList();
    }
  },
  methods: {
    changePage(page) {
      this.Page = page;
      this.getSmsWorkflowList();
    },
    changePerPage(e) {
      this.getSmsWorkflowList();
    },
    getSmsWorkflowList() {
      this.loading = true;
      this.$store
        .dispatch("GetSmsWorkflowList", {
          page: this.Page,
          per_page: this.per_page ? this.per_page : 10,
          sms_workflow_name: this.Searched
        })
        .then(res => {
          this.Page = res.page;
          this.TotalPages = res.total / res.per_page;
          this.smsWorkflows = res.items.map(this.transformItems);
          this.loading = false;
        });
    },
    transformItems(i, k) {
      return {
        name: i.sms_workflow_name,
        createdBy: i.created_by,
        assignedTo: i.assigned_to,
        createdOn: format(i.created_on, "D MMM YYYY"),
        smsWorkflowId: i.sms_workflow_uuid
      };
    },
    deletSmsWorkflow(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this sms!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it"
      }).then(result => {
        if (!result.value) {
          return;
        }
        this.$store.dispatch("DeleteSmsWorkflow", id).then(res => {
          this.getSmsWorkflowList();
          this.$swal("Deleted!", "Your sms has been deleted.", "success");
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.product-container {
  padding: 0 20px;

  .per-page {
    margin-top: 20px;
    padding: 0;
  }
  .perPage {
    width: 120px;
    display: inline-block;
  }
  span {
    margin-top: 7px;
    margin-right: 10px;
  }

 table.Invoice_table {
  width: 99%;
  //   tbody tr:nth-of-type(odd) {
  //     background-color: rgba(0, 0, 0, 0.05);
  // }
}
table thead tr {
  background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
  th {
    border-bottom-width: 2px;
    color: white;
    padding-left: 10px;
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6;
    border: 1px solid #dee2e6;
  }
}
table,
tr {
  width: 100%;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}

table {
  border-collapse: collapse;
}
.Invoice_table_popup {
  width: 75px;
}
.Invoice_table_header th {
  color: white;
  padding-left: 10px;
  border-bottom-width: 2px;
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  border: 1px solid #dee2e6;
  padding: 0.75rem;
  text-align: center;
}
.Invoice_table_header th:first-child {
  padding-left: 20px;
  padding-right: 30px;
  width: 14%;
}
tbody th:first-child {
  padding-left: 20px;
  padding-right: 30px;
}
.popup_content {
  display: none;
}
.popup_cta {
  cursor: pointer;
  padding-right: 5px;
}
.Invoice_table_popup {
  text-align: right;
  position: relative;
}
tbody th {
  height: 40px;
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  font-size: 14px;
  line-height: 20px;
  padding: 12px 20px;
}
  .buttons-wrapper {
    justify-content: flex-end;
  }
  @media (max-width: 891px) {
    .right-wrapprr {
      width: 100% !important;
    }
  }
  @media (max-width: 767px) {
    .add-navigation {
      display: block !important;
      height: auto !important;
    }
    .custom-row {
      width: 100% !important;
    }
    .buttons-wrapper {
      justify-content: flex-start !important;
      margin-top: 15px;
    }
    .primary-button {
      margin-top: 15px;
    }
  }
  @media (max-width: 600px) {
    .custom-row {
      display: block !important;
    }

    .buttons-wrapper {
      width: 100% !important;
    }
    .col-lg-6.col-md-7.col-xs-12 {
      margin-top: 15px;
    }
  }
  .add-navigation {
    font-family: "Helvetica Neue";
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .search-input {
      height: 40px;
      width: 100%;
      background-color: #ffffff;
    }
    .primary-button {
      height: 40px;
      width: 150px;
    }
  }

 
  .popup_content {
    display: none;
  }
  .popup_cta {
    cursor: pointer;
  }
  .Invoice_table_popup {
    text-align: right;
    position: relative;
    padding: 10px 15px 10px 0;
  }

  tbody th.icon-right {
    height: 44px;
    display: flex;
    padding: 7px 0 7px 0;
    float: right;
    .svg-grey {
      height: 30px;
      width: 30px;
      fill: #55616e;
      margin-right: 20px;
    }
  }
  thead th:first-child {
    padding-left: 35px;
  }
  tbody th:first-child {
    padding-left: 35px;
  }
  tbody th.created_by {
    padding: 7px 0 7px 0;
  }
  .Invoice_price {
    font-family: "Helvetica Neue";
    padding: 13px 0 12px 0;
  }
  .Invoice_table_popup.active .popup_content {
    display: block;
    position: absolute;
    right: 0;
    width: 240px;
    border-radius: 4px;
    background-color: #ffffff;
    box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.1);
    padding-left: 0;
    list-style-type: none;
    text-align: left;
  }
  .Invoice_table_popup.active .popup_content a {
    color: #55616e;
    font-size: 16px;
    line-height: 20px;
    text-decoration: none;
    font-family: "Helvetica Neue";
    padding: 10px 15px;
    display: inline-block;
  }
  .popup_image {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    vertical-align: middle;
    margin-right: 8px;
  }
  th.user_active:after {
    content: "";
    height: 10px;
    width: 10px;
    background-color: #24e2b8;
    position: absolute;
    border-radius: 50%;
    left: 12px;
    top: 17px;
    // margin: 17px 13px 17px 12px;
  }

  th.user_active {
    text-align: left;
    position: relative;
    padding-left: 13px;
  }
}
@media (max-width: 1301px) {
  .product-container table.Invoice_table {
    width: 1000px;
  }
}
.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}
</style>

